<template>
  <CreateForm :showNew="showNew" @close="showNew = false" />

  <transition name="fade" mode="out-in">
    <div class="col-span-full sm:col-span-full pb-8 md:col-span-7">
      <h1 class="text-t1 mb-4">Bevakningar</h1>
      <p class="text-preamble mb-8">
        Här kan du skapa e-postbevakningar och hålla dig uppdaterad på när nya objekt som du är
        intresserad av finns lediga för intresseanmälan.
      </p>

      <h2 class="text-t4 py-6">Aktiva bevakningar</h2>
      <div v-if="isLoading" class="mb-8 grid grid-cols-1 gap-6 md:grid-cols-2">
        <CardLoaderSmall class="flex-1 flex-col p-0" />
        <CardLoaderSmall class="flex-1 flex-col p-0" />
      </div>
      <div v-else-if="subscriptions.length > 0" class="mb-8 grid grid-cols-1 gap-6 md:grid-cols-2">
        <SubscriptionsItem
          v-for="(subscription, index) in subscriptions"
          :key="index"
          :subscription="subscription"
        />
      </div>
      <Box v-if="showAddLoader" class="col-span-full">
        <CardLoaderSmall class="flex-1 flex-col p-0 !ring-0" />
      </Box>
      <Box v-else-if="subscriptions.length > 0" class="col-span-full">
        <h2 class="text-t5 mb-3">Lägg till bevakning</h2>
        <p class="text-b1 mb-6">
          Du kan totalt ha tre aktiva bevakningar samtidigt.
        </p>
        <Button class="w-fit" size="large" @click="showNew = true" :disabled="subscriptions.length>2">Skapa bevakning</Button>
      </Box>
      <Box v-if="!isLoading && subscriptions.length === 0" class="col-span-full">
        <h2 class="text-t6 mb-3">Du har inga aktiva bevakningar</h2>
        <p class="text-b2 mb-6">
          Välj de filtreringar du är intresserad av så skickar vi ut e-post när ett
          nytt objekt med de kriterierna publiceras. Du kan ha totalt 3 st aktiva bevakningar samtidigt.
        </p>
        <Button class="w-fit" size="large" @click="showNew = true">Skapa bevakning</Button>
      </Box>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '@/components/ui/loader';
import Box from '@/components/ui/box';
import Button from '@/components/ui/button';
import SubscriptionsItem from '@/pages/subscriptions/subscription-item';
import CreateForm from '@/pages/subscriptions/create-form';
import Modal from '@/components/ui/modal';
import { RENTALOBJECT_TYPES } from '@/config/constants';
import { orderBy, every } from 'lodash';
import GeneralMixin from '@/mixins/general';
import CardLoaderSmall from '@/components/loader/CardLoaderSmall';

export default {
  mixins: [GeneralMixin],
  components: {
    Box,
    Button,
    Loader,
    SubscriptionsItem,
    Modal,
    CreateForm,
    CardLoaderSmall,
  },
  data() {
    return {
      isLoading: true,
      showAddLoader: true,
      // testAlwaysLoading: true,
      RENTALOBJECT_TYPES,
      subscriptionItem: null,
      showNew: false,
    };
  },
  methods: {
    every: every,
    setFocus() {
      setTimeout(() => {
        $('.grid .form-group .multiselect').first().focus();
      }, 100);
    },
    cancel() {
      this.$emit('done');
    },
  },
  created() {
    // Skrolla alltid till toppen
    window.scroll(0, 0);

    if (this.testAlwaysLoading) {
      return;
    }

    setTimeout(() => {
      this.showAddLoader = false;
    }, 500);

    if (!this.testAlwaysLoading) {
      new Promise((resolve) => setTimeout(resolve, 500)).then(() => {
        return Promise.all([
          this.$store.cache.dispatch('fetchSubscriptions'),
          this.$store.cache.dispatch('getConfig'),
        ]).finally(() => {
          this.isLoading = false;
        });
      });
    }
  },

  computed: {
    subscriptions() {
      return orderBy(
        this.$store.getters.subscriptions,
        ['objectType', 'enabled', 'registered'],
        ['asc', 'desc', 'desc'],
      );
    },
    ...mapGetters({
      config: 'config',
      webapp_config: 'webapp_config',
      authStatus: 'authStatus',
    }),
  },
};
</script>
